export const exceptionHandlingDetailAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }